import React, { useEffect, useState, useContext } from 'react';
import { navigate } from 'gatsby';
import {
  ChatBubbles,
  ThumbsUp,
  ThumbsDown,
  CloseChat,
  Disconnect,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import {
  ModalBackgroundStyled as ModalBackground,
  MenuStyled as Menu,
  CircleButtonStyled as CircleButton,
  ChipButtonStyled as ChipButton,
  HeaderStyled as Header,
} from './styles/ChatFeedbackStyled';
import AppContext from '../../App/AppContext';
import PageContext from '../../../contextProvider/PageContext';
import ToastContext from '../../../contextProvider/ToastContext';
import GoogleTagManager from '../../../helpers/GoogleTagManager';

const STAGE = {
  INACTIVE: 1,
  FOUND_OR_NOT: 2,
  CLOSE_OR_NOT: 3,
  CHAT: 4,
};

const lockScroll = lock => {
  if (typeof document !== 'undefined') {
    if (lock) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.position = 'initial';
      document.body.style.width = 'auto';
    }
  }
};

const ChatFeedback = () => {
  const { location } = useContext(PageContext);
  const { setToastProps } = useContext(ToastContext);
  const { setShowChatbot } = useContext(AppContext);
  const [stage, setStage] = useState(STAGE.INACTIVE);
  const isActive = [STAGE.FOUND_OR_NOT, STAGE.CLOSE_OR_NOT].includes(stage);
  const stageTag = {
    [STAGE.FOUND_OR_NOT]: 'Encontraste lo que buscabas',
    [STAGE.CLOSE_OR_NOT]: 'Quieres continuar',
  }[stage];

  const goToStage = (to, buttonTag) => e => {
    e.stopPropagation();
    if (buttonTag) {
      GoogleTagManager.tagInteractiveEvent({
        eventCategory: 'Chat de ayuda',
        eventAction: `Presionar Botón - ${buttonTag}`,
        eventTag: `Vista Feedback - ${stageTag}`,
      });
    }
    if (to === STAGE.CHAT) {
      setShowChatbot(true);
      setStage(STAGE.INACTIVE);
      return;
    }
    setStage(to);
  };
  const closeChat = () => {
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Chat de ayuda',
      eventAction: `Presionar Botón - Cerrar chat`,
      eventTag: `Vista Feedback - ${stageTag}`,
    });
    setToastProps(() => ({
      message: 'Se ha cerrado el chat de ayuda',
      variant: 'info',
    }));
    navigate(location.pathname);
  };

  useEffect(() => {
    if (isActive) lockScroll(true);
    else lockScroll(false);
    return () => {
      if (isActive) lockScroll(false);
    };
  }, [isActive]);

  useEffect(() => {
    if (isActive) {
      const step = {
        [STAGE.FOUND_OR_NOT]: 1,
        [STAGE.CLOSE_OR_NOT]: 2,
      }[stage];
      GoogleTagManager.pushToDataLayer({
        event: 'pagina-virtual',
        page: `/chat-de-ayuda/feedback-paso${step}`,
        pagename: `Chat de ayuda - Feedback paso ${step}`,
      });
    }
  }, [stage, isActive]);

  if (stage === STAGE.CLOSE_OR_NOT) {
    return (
      <ModalBackground onClick={goToStage(STAGE.INACTIVE)}>
        <Menu>
          <Header>¿Quieres continuar con el chat de ayuda?</Header>
          <ChipButton onClick={goToStage(STAGE.INACTIVE, 'Después')}>
            <Disconnect />
            <span>Después</span>
          </ChipButton>
          <ChipButton onClick={goToStage(STAGE.CHAT, 'Volver al chat')}>
            <ChatBubbles />
            <span>Volver al chat</span>
          </ChipButton>
          <CircleButton onClick={closeChat} text="Cerrar chat">
            <CloseChat />
          </CircleButton>
        </Menu>
      </ModalBackground>
    );
  }
  if (stage === STAGE.FOUND_OR_NOT) {
    return (
      <ModalBackground onClick={goToStage(STAGE.INACTIVE)}>
        <Menu>
          <Header>¿Encontraste lo que buscabas?</Header>
          <ChipButton onClick={goToStage(STAGE.CLOSE_OR_NOT, 'Sí lo encontré')}>
            <ThumbsUp />
            <span>Sí lo encontré</span>
          </ChipButton>
          <ChipButton onClick={goToStage(STAGE.CHAT, 'No, ir al chat')}>
            <ThumbsDown />
            <span>No, ir al chat</span>
          </ChipButton>
          <CircleButton onClick={closeChat} text="Cerrar chat">
            <CloseChat />
          </CircleButton>
        </Menu>
      </ModalBackground>
    );
  }
  return (
    <Menu>
      <CircleButton onClick={goToStage(STAGE.FOUND_OR_NOT)}>
        <ChatBubbles />
      </CircleButton>
    </Menu>
  );
};

export default ChatFeedback;
